import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core'
import {faTimes} from '@fortawesome/pro-solid-svg-icons/faTimes'

@Component({
  selector: 'cft-filter-bar',
  templateUrl: './filter-bar.component.html',
  styles: `
    @reference "../../../../styles/app-reference.css";
    :host {
      @apply flex items-center gap-4;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterBarComponent {
  @Input() showClear = false
  @Output() clear = new EventEmitter()
  protected readonly clearIcon = faTimes
}
